import {
  Boxes,
  CalendarRange,
  Calculator,
  FolderTree,
  BadgeDollarSign,
  Inbox,
  Tags,
  Layers,
  LayoutDashboard,
  LifeBuoy,
  Network,
  Package,
  PackageCheck,
  PartyPopper,
  Rocket,
  Shield,
  Stamp,
  UserX,
  Users,
  type LucideIcon,
} from 'lucide-react';

/**
 * Small static icon registry. Module `icon` strings map here. Kept explicit
 * (not a dynamic import by name) so the bundle is predictable and tree-shaken.
 */
const ICONS: Record<string, LucideIcon> = {
  dashboard: LayoutDashboard,
  calculator: Calculator,
  package: Package,
  shield: Shield,
  network: Network,
  users: Users,
  'calendar-range': CalendarRange,
  // PIM. `package` is already Quoting → Catalog, and two catalogue-ish sections sharing
  // one glyph is exactly the confusion the separate /pim/* prefix exists to avoid.
  boxes: Boxes,
  layers: Layers,
  'folder-tree': FolderTree,
  tags: Tags,
  // Quoting → RFQs, every kind's queue.
  inbox: Inbox,
  // Quoting → Approvals, the margin sign-off inbox.
  stamp: Stamp,
  // The team roadmaps, under Company beside the wall planner.
  'package-check': PackageCheck,
  rocket: Rocket,
  'party-popper': PartyPopper,
  // Pricing → Settings.
  'badge-dollar-sign': BadgeDollarSign,
  'life-buoy': LifeBuoy,
  'user-x': UserX,
};

export function Icon({ name, className }: { name: string; className?: string }) {
  const Cmp = ICONS[name] ?? LayoutDashboard;
  return <Cmp className={className} />;
}
